import clsx from 'clsx';
import { Overlay, Popover } from 'react-bootstrap';
import { useInputSelectContext } from '../context';
import TableSelect from './TableSelect';
import { DropdownProps } from '../types';

const DropdownList = ({ targetElement, containerElement, onRowSelect, columns }: DropdownProps) => {
	const { isLoading, options, show } = useInputSelectContext();

	return (
		<Overlay
			target={targetElement}
			container={document.getElementById('root')}
			show={show}
			offset={[0, 3]}
			placement="bottom-start"
		>
			<Popover
				style={{
					minWidth: containerElement?.clientWidth,
				}}
				className="popover-arrow-hidden"
			>
				<Popover.Body
					className={clsx('p-1', {
						'd-none': !options?.length,
					})}
				>
					{isLoading ? (
						<div className="px-3 py-2 text-center">Đang tải dữ liệu ...</div>
					) : (
						<div className="mh-250px overflow-y-auto">
							<TableSelect
								columns={columns}
								data={options}
								onRowSelect={onRowSelect}
							/>
						</div>
					)}
				</Popover.Body>
			</Popover>
		</Overlay>
	);
};

export default DropdownList;
